// extracted by mini-css-extract-plugin
module.exports = {"scroller":"styles_scroller__1_sAE"};